var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basestaStyle"},_vm._l((_vm.statisticData),function(item,index){return _c('div',{staticClass:"staOneDiv"},[_c('div',[_c('span',[_vm._v(_vm._s(item.name))])]),_c('div',[_c('span',[_vm._v(_vm._s(item.number))])])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }